<template>
  <div class="exam-content-smw">
    <div class="title">
      You will hear a recording about fiction writing. At the end of the
      recording the lost word or group of words has been replaced by a beep.
      Select the correct option to complete the recording.
    </div>
    <div class="body">
      <div class="audio">
        <Audio :url="detail.audio.url" :time="7" />
      </div>
      <div class="ipt">
        <Radio :list="detail.check.options" :onInput="handleCheck" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/api/exam'
import Radio from '../../components/radio'
import Audio from '../../components/audio'

export default {
  components: {
    Radio,
    Audio
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    itemData: {
      type: Object,
      default: () => ({})
    },
    infoData: {
      type: Object,
      default: () => ({})
    },

    onFinish: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      checkList: []
    }
  },
  mounted() {
    this.SetTimeType({ type: 'LISTEN' })
  },
  methods: {
    ...mapActions('exam', ['SetTimeType']),
    submit() {
      if (this.checkList && this.checkList.length > 0) {
        this.handleSave()
        return true
      }
      return false
    },
    async handleSave() {
      await api.submit({
        my_exam_id: this.examInfo.my_exam_id,
        qid: this.itemData.gre_try_id,
        contents: [...this.checkList]
      })
      this.onFinish()
    },

    handleCheck(list) {
      this.checkList = list
    }
  }
}
</script>

<style scoped lang="scss">
.exam-content-smw {
  color: #1f1f40;
  .title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }
  .body {
    width: 1014px;
    margin: 0 auto;
  }
  pre {
    margin-top: 24px;
    font-size: 18px;
    line-height: 32px;
    word-break: break-word;
    word-spacing: normal;
    white-space: pre-wrap;
  }
  .ipt {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .audio {
    margin-top: 14px;
    display: flex;
    justify-content: center;
  }
}
</style>
